<div class="alert alert-warning push-status-message-container" [hidden]="!pushConnectionInitialized || pushConnectionHealthy">
	<span class="warning">
		{{ 'ConnectionError_Warning' | translate }}
	</span>
</div>
